import {tt} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {
  SHORTCUT_COLOR_MAP,
  SHORTCUT_HOME_ICON_MAP,
  SHORTCUT_TEXT_MAP,
} from '../../../domain/shortcut/list/constant';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {Text} from '../../atoms/Text/Text';
import {ShortcutHomeButtonProps} from './ShortcutHomeButtonProps.interface';

export function ShortcutHomeButton({
  shortcutHomeType,
  className,
}: ShortcutHomeButtonProps) {
  return (
    <div className={twMerge(['flex flex-col items-center', className])}>
      <div
        className="flex h-68pxr w-full cursor-pointer items-center justify-center rounded-20pxr"
        style={{
          backgroundColor: SHORTCUT_COLOR_MAP[shortcutHomeType],
          boxShadow: 'inset 0px -1px 0px rgba(0, 0, 0, 0.2)',
        }}
      >
        <StaticImage
          className="h-68pxr w-68pxr"
          imageType={SHORTCUT_HOME_ICON_MAP[shortcutHomeType]}
        />
      </div>
      <Text className="font-small1-bold mt-8pxr text-theme-solid-100">
        {tt(SHORTCUT_TEXT_MAP[shortcutHomeType])}
      </Text>
    </div>
  );
}
